import { z } from "zod";
export const narrativeFactSchema = z.object({
  kind: z.enum([
    "character",
    "relationship",
    "event",
    "location",
    "item",
    "task",
    "monster",
    "world",
  ]),
  subject: z.string().min(1).max(100),
  content: z.string().min(2).max(600),
  confidence: z
    .enum(["confirmed", "reported", "inferred"])
    .default("confirmed"),
  keywords: z.array(z.string().min(1).max(40)).max(12).default([]),
});
export const narrativeIngestSchema = z.object({
  summary: z.string().max(2400),
  facts: z.array(narrativeFactSchema).max(24),
});
export type NarrativeIngest = z.infer<typeof narrativeIngestSchema>;
export function parseNarrativeIngestPayload(raw: string): NarrativeIngest {
  const fenced = raw.match(/```(?:json)?\s*([\s\S]*?)```/i)?.[1];
  const candidate =
    fenced ?? raw.slice(raw.indexOf("{"), raw.lastIndexOf("}") + 1);
  return narrativeIngestSchema.parse(JSON.parse(candidate));
}
